import { render, staticRenderFns } from "./InviteForm.vue?vue&type=template&id=773a04d2&scoped=true"
import script from "./InviteForm.vue?vue&type=script&lang=js"
export * from "./InviteForm.vue?vue&type=script&lang=js"
import style0 from "./InviteForm.vue?vue&type=style&index=0&id=773a04d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773a04d2",
  null
  
)

export default component.exports